module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADrSURBVEhL7dM7CsJAFIXhsRAFQXQDCnZi7RLE1iXYuQddgGIjaOVGFB+NhZWFS7BwCYJgIfqfkAExQcgkKYQc+AgJ4d65k4nJ4qeAOe6Y6EGSKeOAl09NnDLDCEOc0IVSwgBH3DCGU5awq5QFYqWNKVbenTEdqPAZPRQROS2o6AWfq20ijzUqcEofT9iiaqJmmsQm51+dcoUKa28/iyaWB9Sg6t2lkD3s9rjSIneoIRA93MJOEoeapJIG1EA/XCB1qHMSE2wQSFLfQNsc+g00ll7SmKkkO0XKz1P0vYo4Qk9R2ItR/TxF/xhj3l0jve0cjAF+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-water-hose/dark/24.png
// module id = 2548
// module chunks = 2